// v77.99.61 — Reusable "Filtered: <child>" badge.
//
// Surfaces the global child-scope state on individual pages so users
// can see at a glance whether they're looking at a narrowed view.
// Self-hides when the scope is "All children" (master view).
//
// Mirrors the look of the existing inline badge on the Insights page
// (soft sand tint, low-contrast border, sentence-case) so the entire
// app feels visually consistent. The original Insights badge has been
// kept in place to avoid layout shift; new pages should use this one.

import { useMemo } from "react";
import { useChildScope } from "@/context/ChildScopeContext";

export function ChildScopeBadge({ className = "", testid = "child-scope-badge" }) {
  const { children, selectedChildId } = useChildScope();
  const activeChildName = useMemo(() => {
    if (!selectedChildId) return null;
    const c = (children || []).find((x) => x.id === selectedChildId);
    return c?.name || null;
  }, [selectedChildId, children]);

  if (!activeChildName) return null;

  return (
    <span
      className={`text-[11px] px-2 py-0.5 border rounded-sm bg-[#F5F1EA] text-[#6F4E1E] border-[#EADFC9] inline-flex items-center gap-1 flex-shrink-0 ${className}`}
      data-testid={testid}
      title={`Showing only data for ${activeChildName}. Switch back to "All children" in the top bar to widen the view.`}
    >
      <span className="opacity-70">Filtered:</span> {activeChildName}
    </span>
  );
}
